<template>
  <div
    ref="image"
    class="zoom-container"
  >
    <Spinner :show="this.showSpinner" />
    <img
      v-show="blobUrl"
      class="zoom-figure-image"
      :src="blobUrl"
      :alt="imgAlt"
    >
    <div
      v-if="legend && legend.length > 0"
      :class="legend.length > 6 ? 'extra-margin' : ''"
      class="legend-container"
    >
      <div
        v-for="(legendItem, index) in legend"
        :key="legendItem.label + index"
      >
        <span class="ref-number">{{ legendItem.ref_number }}</span>
        {{ legendItem.label }}
      </div>
    </div>
  </div>
</template>

<script>

import PinchZoom from 'pinch-zoom-js';
import Spinner from './Spinner.vue';

export default {
  name: 'ZoomImage',
  components: { Spinner },
  props: {
    imgUrl: {
      type: String,
      required: true,
    },
    imgAlt: {
      type: String,
      required: true,
    },
    legend: {
      type: Array,
    },
    cytkAccessToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      zoomOptions: {
        maxZoom: 5,
        minZoom: 0.2,
        lockDragAxis: false,
      },
      blobUrl: undefined,
      showSpinner: false,
    };
  },
  mounted() {
    this.initZoomable();
    this.showSpinner = true;
    // fetch the image
    this.fetchImage(this.imgUrl, this.cytkAccessToken).then((blob) => {
      this.blobUrl = URL.createObjectURL(blob);
    }).finally(() => {
      this.showSpinner = false;
    });
  },
  beforeDestroy() {
    this.zoom.destroy();
  },
  methods: {
    initZoomable() {
      this.zoom = new PinchZoom(this.$refs.image, this.zoomOptions);
    },
  },
};
</script>

<style scoped lang="scss">
.zoom-container {
  background-color: $surface-light;
  padding-top: 20px;

  .zoom-figure-image {
    background-color: $surface-light;
    width: 100%;
    height: auto;
  }

  .legend-container {
    font-size: 10px;
    background-color: $surface-light;
    color: $text-secondary;
    padding: 2px 6px;

    &.extra-margin {
      margin-bottom: 130px;
    }

  }

  .ref-number {
    font-weight: bold;
    margin-right: 6px;
  }
}

</style>
